import Vue from 'vue'
import { Button,
    Form,
    FormItem,
    Input,
    Message,
    Container,
    Header,
    Main,
    Aside,
    Menu,
    Submenu,
    MenuItem,
    Breadcrumb,
    BreadcrumbItem,
    Card,
    Row,
    Col,
    Table,
    TableColumn,
    Switch,
    Tooltip,
    Pagination,
    Dialog,
    Image,
    Avatar,
    Select,
    Option,
    PageHeader,
    Alert,
    Upload,
    Link,
    MessageBox,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Backtop,
    Radio,
    RadioGroup,
    Skeleton,
    SkeletonItem,
    Carousel,
    CarouselItem,
    Icon,
    DatePicker,
    Popover
} from 'element-ui'

Vue.use(Button)
Vue.use(Icon)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(SkeletonItem)
Vue.use(Skeleton)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Backtop)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Link)
Vue.use(Upload)
Vue.use(Alert)
Vue.use(PageHeader)
Vue.use(Option)
Vue.use(Select)
Vue.use(Avatar)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(Switch)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(BreadcrumbItem)
Vue.use(Breadcrumb)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Aside)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
